import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Header, Icon, Message } from 'components/HeroSemantic';

import { ownersContacts } from '../../constants';

const NoDataFound = ({ iconColor, iconName, message }) => {
  const tenantId = useSelector(state => state.tenant.id);
  const defaultMessage = <FormattedMessage id="error.noDataFound" values={{ email: ownersContacts.email[tenantId] }} />;

  return (
    <Message
      className="mx-auto max-w-5xl border-[var(--owner-info-border)] bg-[var(--owner-surface)] px-8 py-8 text-center text-[var(--owner-text)] shadow-sm"
      size="massive"
      style={{
        background: 'var(--owner-accent-subtle)',
        borderColor: 'var(--owner-accent-border)',
        color: 'var(--owner-text)',
      }}
    >
      <Icon
        size="large"
        color={iconColor}
        name={iconName}
        style={{
          color: iconColor ? undefined : 'var(--owner-accent-readable)',
          margin: '0 auto 18px',
          display: 'block',
        }}
      />
      <Header as="h3" className="mx-auto max-w-3xl text-center text-lg leading-7">
        { message || defaultMessage }
      </Header>
    </Message>
  );
};

NoDataFound.propTypes = {
  iconColor: PropTypes.string,
  iconName: PropTypes.string,
  message: PropTypes.string,
};

NoDataFound.defaultProps = {
  iconColor: undefined,
  iconName: 'warning circle',
};

export default NoDataFound;
